module.exports = __webpack_public_path__ + "img/aws-certified-cloud-practitioner.c378a921.png";